export const getDatasetList = (
  host: string,
  apiky: string,
  token: string,
  siteId: number,
  userId: number
) => {
  const reqestURL = `${host}/datasets?site_id=${siteId}&user_id=${userId}&owner=1`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Client-Service", "frontend-client");
  reqestHeader.set("Auth-Key", apiky);
  reqestHeader.set("Authorization", token);
  reqestHeader.set("User-ID", `${userId}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      let dataList = [];
      if (Array.isArray(response.data)) {
        dataList = response.data;
      } else {
        dataList = [response.data];
      }
      return dataList;
    })
    .catch(error => {
      return error;
    });
};
